/* eslint-disable no-await-in-loop */

import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { axiosInstance } from "../axios-instance";

class SimRecredential {
  private client: OAuth2Client | null;
  
  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.client = authClient;
    this.baseUrl = baseUrl;
  }

  requestSimRecredential(
    body: any,
  ): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/requestSimRecredential`,
      body,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }
}

export default SimRecredential;